import { endpoints } from '../endpoints'
import { http } from '../http'
import { ObituaryMemoryComment, ObituaryMemoryCommentParams } from '../../types'

interface ObituaryMemoryCommentsAPI {
  create: (
    obituaryMemoryID: number,
    params: ObituaryMemoryCommentParams,
  ) => Promise<ObituaryMemoryComment>
}

export const obituaryMemoryComments: ObituaryMemoryCommentsAPI = {
  create: (obituaryMemoryID, params) => {
    return http.post(endpoints.obituaryMemoryComments(obituaryMemoryID), {
      obituary_memory_comment: params,
    })
  },
}
